import React from "react";

const NotificationCallCreated = () => {
  return (
    <div className="flex flex-col gap-4 p-2">
      <div>Ocurrió un problema al actualizar el agente</div>
    </div>
  );
};
export default NotificationCallCreated;
